import { apiGet, apiPost, apiPatch } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

export const supportApi = {
  getCategories: () => apiGet<{ data: Record<string, unknown>[] }>("/support/categories"),

  getMyTickets: (params?: PaginatedParams & { status?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.status) searchParams.set("status", params.status);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/support/tickets?${searchParams.toString()}`);
  },

  getTicket: (id: string) => apiGet<{ data: Record<string, unknown> }>(`/support/tickets/${id}`),

  createTicket: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>("/support/tickets", body),

  addReply: (id: string, body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`/support/tickets/${id}/reply`, body),

  getAllTickets: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/support/admin/tickets?${searchParams.toString()}`);
  },

  updateTicketStatus: (id: string, status: string) => apiPatch<{ data: Record<string, unknown> }>(`/support/tickets/${id}/status`, { status }),

  assignTicket: (id: string, assigneeId: string) => apiPatch<{ data: Record<string, unknown> }>(`/support/tickets/${id}/assign`, { assigneeId }),
};
